<template>
  <div>
    <sweet-modal style="z-index: 10001" :title="$t('ct-add-icon-title')" ref="modal" width="70vw">
      <div class="text-icons-input-container input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text"><font-awesome-icon icon="search"/></span>
        </div>
        <input type="text" class="form-control" :placeholder="$t('ct-search')" v-model="filter">
        <div class="input-group-append">
          <button class="btn btn-primary btn-small" type="button" @click="filterSelection">{{ $t('ct-search') }}
          </button>
        </div>
      </div>
      <div class="text-icons-container" ref="text-icons-container" v-if="!loading && iconList.length > 0">
        <div v-for="(element,index) in iconList" :key="index" class="item-icon show" :data-name="element">
          <i :class="'mdi '+element" @click="focusIcon(element)" :value="element"></i>
        </div>
        <div v-show="showColor">ShowColor</div>
      </div>
      <div class="text-icons-container" v-else-if="!loading && iconList.length === 0">
        <p class="mb-0 text-center">{{ $t('ct-icon-not-found')}}</p>
      </div>

      <div class="text-icons-container" v-else>
        <div class="text-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>

      <button slot="button" class="btn btn-outline-light" @click="close">{{ $t('ct-cancel') }}</button>
      <button slot="button" class="btn btn-success" @click="save"><i class="svg-icon svgi-save"></i>{{ $t('ct-select') }}</button>
    </sweet-modal>
  </div>
</template>
<script>

import IconList from './Abstract/IconList';
import {SweetModal} from 'sweet-modal-vue';

export default {
  name: 'TextIconComponent',
  components: {
    IconList,
    SweetModal
  },
  data() {
    return {
      element: null,
      value: '',
      labelDesc: 'opa',
      callback: null,
      showColor: false,
      filter: '',
      iconSelected: '',
      position: '',
      iconList: [],
      loading: false
    };
  },
  methods: {

    save() {
      this.callback(this.iconSelected, '#000');
      this.$refs.modal.close();
      this.$root.$emit('blurEvent', true);
    },

    close() {
      this.iconSelected = '';
      this.$refs.modal.close();
      this.$root.$emit('blurEvent', true);
    },

    focusIcon(icon) {

      if (icon === this.iconSelected)
        return;

      let elements = this.$refs['text-icons-container'].getElementsByClassName('focused');
      [].forEach.call(elements, function(el) {
        el.classList.remove('focused');
      });


      this.iconSelected = icon;
      let i, x;
      x = this.$refs['text-icons-container'].getElementsByClassName(icon);
      for (i = 0; i < x.length; i++) {
        this.addClass(x[i], 'focused');
      }
    },
    addClass(element, name) {
      var i, arr1, arr2;
      arr1 = element.className.split(' ');
      arr2 = name.split(' ');
      for (i = 0; i < arr2.length; i++) {
        if (arr1.indexOf(arr2[i]) == -1) {
          element.className += ' ' + arr2[i];
        }
      }
    },

    removeClass(element, name) {
      var i, arr1, arr2;
      arr1 = element.className.split(' ');
      arr2 = name.split(' ');
      for (i = 0; i < arr2.length; i++) {
        while (arr1.indexOf(arr2[i]) > -1) {
          arr1.splice(arr1.indexOf(arr2[i]), 1);
        }
      }
      element.className = arr1.join(' ');
    },
    filterSelection() {
      let vm = this;
      let c = this.filter.toLowerCase().trim();
      this.loading = true;

      setTimeout(function() {
        vm.loading = false;
      }, 500);

      if (c.length > 0) {
        let iconsList = IconList.data().props.iconList.filter(icon => icon.indexOf(c) > -1)
        this.iconList = [...new Set(iconsList)]; // remove duplicados
      } else {
        let iconsList = IconList.data().props.iconList;
        this.iconList = [...new Set(iconsList)]; // remove duplicados
      }
    },
    showIconList() {
      let vm = this;
      this.loading = true;

      let elements = document.getElementsByClassName('widget-focused');
      [].forEach.call(elements, function(el) {
        el.classList.remove('widget-focused');
      });

      let iconsList = IconList.data().props.iconList;
      this.iconList = [...new Set(iconsList)]; // remove duplicados

      this.$refs.modal.open();

      setTimeout(function() {
        vm.loading = false;
      }, 500);
    }
  },
  mounted() {
    let vm = this;
    this.$root.$on('showIconList', (callback, showColor) => {
      vm.showColor = showColor;
      vm.callback = callback;
      vm.showIconList();
    });
  }
};
</script>
<style scoped lang="scss">
  .form-group {
    overflow: hidden;
  }
</style>
<style lang="scss">
  .item-icon {
    display: none;
    width: 40px;
    height: 40px;
    font-size: 30px;
    cursor: pointer;

    .focused {
      border-radius: 5px;
      color: #FFF;
      background-color: #0080FC;
    }

    .mdi {
      width: 40px;
      height: 40px;
      text-align: center;
    }
  }

  .text-icons-input-container {
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    border-radius: 3px;
    height: 46px;

    .input-group-append {
      .btn {
        height: 100%;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        box-shadow: none;

        font-size: 13px;
        font-weight: bold;
        font-family: "Muli", "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif;
      }
    }

    .input-group-text {
      margin-left: 5px;

      background: none;
      border: none;
      color: #A8A8A8;
    }

    input {
      height: 40px;
      border: none;
      margin-top: 3px;

      font: normal normal normal 14px Lato;
      color: #656565;
    }
  }

  .text-icons-container {
    padding: 20px;
    max-height: 50vh;
    overflow: auto;
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    border-radius: 3px;

    .item-icon {
      margin-left: 3px;
      margin-right: 3px;

      &.show {
        display: inline-flex;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/resources/TextIcon.vue